const header = () => {
  /*
   * SELECTORS
   */

  /*
   * EVENTS
   */

  /*
   * ACTIONS
   */
  /*
   * EXTRA EXPORTS
   */
};
export default header;



// WEBPACK FOOTER //
// ./scripts/components/header.js